import { render, staticRenderFns } from "./methods.vue?vue&type=template&id=91b44578&"
import script from "./methods.vue?vue&type=script&lang=js&"
export * from "./methods.vue?vue&type=script&lang=js&"
import style0 from "./methods.vue?vue&type=style&index=0&id=91b44578&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CheckoutPaymentMethodHeader: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/Checkout/Payment/MethodHeader.vue').default,CheckoutPaymentFormPayzen: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/Checkout/Payment/Form/payzen/index.vue').default,CheckoutPaymentFormPaypal: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/Checkout/Payment/Form/paypal/index.vue').default,CheckoutPaymentFormStripe: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/Checkout/Payment/Form/stripe/index.vue').default,CheckoutPaymentFormAlma: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/Checkout/Payment/Form/alma/index.vue').default})
